export default class ContactFormPopup
{

    identifier = 'KundendienstTrainer.ContactFormPopup'; // LocalStorage identifier
    timeout = 30; // Show popup after a delay of ... seconds
    expires = 2592000; // The localStorage expires after ... seconds
    contactFormPopup = null;

    constructor()
    {
        if (localStorage.getItem(this.identifier)) {
            const unixTimestampLocalStorage = Math.round(localStorage.getItem(this.identifier) / 1000);
            const unixTimestampNow = Math.round(Date.now() / 1000);
            if (unixTimestampNow - unixTimestampLocalStorage > this.expires) {
                localStorage.removeItem(this.identifier);
            }
        }
        const contactForm = document.getElementById('uid-10475');
        if (contactForm && typeof localStorage.getItem(this.identifier) !== 'string') {
            this.contactFormPopup = document.createElement('div');

            setTimeout(() => {
                this.contactFormPopup.id = 'contact-us-NOW';
                this.contactFormPopup.innerHTML = contactForm.innerHTML;
                this.contactFormPopup.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
                const closeButton = document.createElement('button');
                closeButton.classList.add('close');
                closeButton.textContent = 'Schließen';
                closeButton.addEventListener('click', () => {
                    this.dismissContactFormPopup(true);
                });
                this.contactFormPopup.appendChild(closeButton);
                this.contactFormPopup.querySelector('form').setAttribute('target', '_blank');
                this.contactFormPopup.querySelector('form').addEventListener('submit', () => {
                    this.dismissContactFormPopup(true);
                });
                document.body.appendChild(this.contactFormPopup);
                setTimeout(() => {
                    this.contactFormPopup.classList.add('show');
                }, 250);
            }, 1000 * this.timeout);
            document.body.addEventListener('click', (e) => {
                this.dismissContactFormPopup();
            });
        }
    }

    dismissContactFormPopup (disable=false)
    {
        if (this.contactFormPopup.classList.contains('show')) {
            this.contactFormPopup.classList.remove('show');
            if (disable) {
                localStorage.setItem(this.identifier, Date.now());
            }
        }
    }

}